<template>
  <with-root :show="student.url">
    <a class="card__link" :href="student.url" target="_blank">
      <card class="card--student"
        :horizontal="horizontal"
        :card-color="cardColor"
        :text-color="textColor"
        :accent-color="accentColor"
        :border-color="borderColor"
        :class="{ active: student.status && student.status.toLowerCase() === 'in-progress' }">
        <template v-slot:media v-if="toBase(student.image || placeholderImage)">
          <img
            class="card--student__image"
            :src="toBase(student.image || placeholderImage)"
            :alt="'Image ' + student.title" />
        </template>
        <template v-slot:header>
          <h6 class="card--student__title">{{ student.title }}</h6>
        </template>
        <template v-slot:body>
          <div class="card--student__body__wrapper">
            <p v-if="student.student" class="card--student__name">
              {{ student.student }}
            </p>
            <p v-if="student.year" class="card--student__year">
              <span class="card--student__label">Year</span><span class="card--student__value">{{ student.year }}</span>
            </p>
            <p v-if="student.degree" class="card--student__degree">
              <span class="card--student__label">Type</span><span class="card--student__value">{{ student.degree }}</span>
            </p>
            <p v-if="student.institution" class="card--student__institution">
              <span class="card--student__label">Institution</span><span class="card--student__value">{{ student.institution }}</span>
            </p>
            <p v-if="student.status" class="card--student__status">
              {{ student.status }}
            </p>
          </div>
        </template>
        <template v-slot:actions>
        </template>
      </card>
    </a>
  </with-root>
</template>

<script>
import { mapGetters } from 'vuex'

import Card from '@/components/Card'

export default {

  name: 'student-card',

  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    cardColor: {
      type: String,
      default: '#ffffff'
    },
    textColor: {
      type: String,
      default: '#ffffff'
    },
    accentColor: {
      type: String,
      default: '#ffffff'
    },
    borderColor: {
      type: String,
      default: '#ffffff'
    },
    student: {
      type: Object,
      default: () => ({
        'title': 'Title of the student\'s work',
        'student': 'Name of the student',
        'image': 'Photo of the student',
        'institution': 'Institution of the student',
        'degree': 'Degree to obtain with the work',
        'year': 'Starting year',
        'status': 'Status of the work',
        'url': 'URL of the student/work'
      })
    },
    placeholderImage: {
      type: String
    }
  },

  components: {
    'card': Card
  },

  computed: {
    ...mapGetters(['toBase'])
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>

a.card__link {
  display: flex;
  text-decoration: none;
  width: 100%;
}

.card--student {

  &__title {
    font-size: 1.3rem;
    color: var(--text-color);
  }

  &__body__wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: flex-end;
  }

  &__name {
    font-style: italic;
    font-size: 1rem;
    padding: 0.5rem 0;
  }

  &__status {
    font-size: 1.1rem;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    padding: 0.5rem;
    margin: 0;
    vertical-align: bottom
  }

  &__year,
  &__degree,
  &__institution {
    display: flex;
  }

  &__label {
    flex: 1;
    font-weight: 600;
    text-transform: capitalize;
  }

  &__value {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StudentCard.vue